import React, {useState, useEffect} from "react";
import {graphql, Link, useStaticQuery} from "gatsby";
import ReverseLogo from '../assets/images/PQ-website-logo-reverse.png';
import Logo from '../assets/images/PQ-website-logo.png';

const isBrowser = typeof window !== "undefined";


const Header = ({pageContext, toggleBackdrop, uri, ...props}) => {
  const [scrolled, setScrolled] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [weather, setWeather] = useState();
  const [parentItems, setParentItems] = useState([]);
  const [childItems, setChildItems] = useState([]);

  const {wpMenu} = useStaticQuery(graphql`
    {
      wpMenu(slug: {eq: "main-menu"}) {
        menuItems {
          nodes {
            label
            url
            order
            parentId
            id
            databaseId
            connectedNode {
              node {
                uri
              }
            }
            childItems {
              nodes {
                label
                title
                url
                id
                connectedNode {
                  node {
                    uri
                  }
                }
              }
            }
          }
        }
        header {
          fieldGroupName
          callNow
        }
      }
    }
  `);

  useEffect(() => {
    if (!wpMenu?.menuItems?.nodes || wpMenu?.menuItems?.nodes === 0) return null;

    const childMenuItems = [];
    const parentMenuItems = [];

    wpMenu.menuItems.nodes.forEach(menuItem => {
      if (!menuItem.parentId) {
        parentMenuItems.push({...menuItem, opened: false});
      } else {
        childMenuItems.push(menuItem);
      }
    });

    setParentItems(parentMenuItems);
    setChildItems(childMenuItems);
  }, []);

  const handleScroll = () => {
    if (isBrowser) {
      const offset = window.scrollY;
      if (offset >= 200) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
  };

  useEffect(() => {
    if (isBrowser) {
      window.addEventListener('scroll', handleScroll);
      let navbar = document.getElementById('site-header');
      let stickyFill = document.getElementById("stickyFill");

      stickyFill.style.paddingTop = navbar.offsetHeight + 'px';

      if (scrolled) {
        navbar.classList.add("sticky");
        stickyFill.style.display = "block";
      } else {
        navbar.classList.remove("sticky");
      }

      // return a cleanup function
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [scrolled]);

  useEffect(() => {
    const abortController = new AbortController();
    const weatherURL = 'https://api.weatherapi.com/v1/current.json?key=fa4f6050cd484fb1ad4172833211304&q=96720';

    fetch(weatherURL, {signal: abortController.signal})
      .then(res => res.json())
      .then(data => {
        setWeather(data);
      })
      .catch(error => {
        // ignore abort errors
        if (error.name === 'AbortError') return;
        throw error;
      });

    return () => {
      abortController.abort();
    };
  }, []);

  const toggleMenu = (e) => {
    setShowMenu(!showMenu);
    const nav = document.getElementById("nav-container");
    const navBurger = document.getElementById("nav-burger");

    if (!showMenu) {
      const toggleMenu = (e) => {
        setShowMenu(!showMenu);
        const nav = document.getElementById("nav-container");
        const navBurger = document.getElementById("nav-burger");

        if (!showMenu) {
          nav.classList.add("opened");
          navBurger.classList.add("opened");
          toggleBackdrop(e, true)
        } else {
          nav.classList.remove("opened");
          navBurger.classList.remove("opened");
          toggleBackdrop(e, false)
        }
      }
    }
  }


  return (
    <header>
      <nav
        id="site-header"
        className={`primary-menu-wrapper ${showMenu ? 'opened' : ''}`}
        aria-label="Horizontal"
        role="navigation"
      >
        <div className="site-logo">
          <Link to="/">
            {scrolled ? <img alt="" src={Logo}/> : <img alt="" src={ReverseLogo}/>}
          </Link>
        </div>
        <button id="nav-burger" className="mobile-menu-toggle" onClick={(e) => toggleMenu(e)}>
          <span className={`line ${scrolled ? 'scrolled' : ''}`}></span>
          <span className={`line ${scrolled ? 'scrolled' : ''}`}></span>
          <span className={`line ${scrolled ? 'scrolled' : ''}`}></span>
        </button>
        <ul id="nav-container" className="nav-container">
          {parentItems.map((parent, i) => {
            const parentPath = parent?.connectedNode?.node?.uri ?? parent.url
            const parentItemId = "menu-item-" + parent.databaseId
            let noMenu = '';

            if (parent.url !== '#') {
              noMenu = 'noMenu';
            }

            return (
              <div className={`nav-item ${noMenu}`} key={i + parent.url}>
                <li
                  id={parentItemId}
                  className={"menu-item " + parentItemId}
                >
                  {parentPath === '#' ? (
                    <span className="nav-parent">
                      {parent.label}
                    </span>
                  ) : (
                    <Link
                      to={parentPath}
                      activeClassName="active"
                      partiallyActive={true}
                      className="nav-parent"
                    >
                      {parent.label}
                    </Link>
                  )}
                </li>
                <div className='dropdown-menu'>
                  {childItems.map((child, index) => {

                    const childPath = child?.connectedNode?.node?.uri ?? child.url
                    const childItemId = "menu-item-" + child.databaseId

                    if (child.parentId === parent.id) {
                      return (
                        <li
                          id={childItemId}
                          key={index + child.url}
                          className={"menu-item " + childItemId}
                        >
                          <Link
                            to={childPath}
                            activeClassName="active"
                            partiallyActive={true}
                          >
                            {child.label}
                          </Link>
                        </li>
                      )
                    }
                  })}
                </div>
              </div>
            )
          })}
          {wpMenu?.header?.callNow && (
            <a className="btn button-solid" href={`tel:${wpMenu?.header?.callNow}`}>Call Now</a>
          )}
          {weather && weather?.current?.temp_f && weather?.location?.name && (
            <div className="weather">
              <span className="temp">{weather?.current?.temp_f}º</span>
              <span className="location">{weather?.location?.name}, HI</span>
            </div>
          )}
        </ul>
      </nav>
      <div id="stickyFill"/>
      <div className={`mobile-nav-container ${showMenu ? 'opened' : ''} ${scrolled ? 'scrolled' : ''}`}>
        {parentItems.map((parent, i) => {

          const parentPath = parent?.connectedNode?.node?.uri ?? parent.url
          const parentItemId = "menu-item-" + parent.databaseId

          const toggleOpenedSub = (item) => {

            setParentItems(parentItems.map(it => {
              if (it.id === item.id) {
                it.opened = !it.opened
              }
              return it
            }))
          }

          return (
            <div
              className={`nav-item ${(parent.childItems && parent.childItems.nodes.length) ? 'parent' : ''} ${parent.opened ? 'open' : 'close'}`}
              key={i + parent.url}>
              <div
                id={parentItemId}
                className={`menu-item ${parentItemId}`}
                onClick={() => toggleOpenedSub(parent)}
              >
                {parentPath === '#' ? (
                  <span>
                    {parent.label}
                  </span>
                ) : (
                  <Link
                    to={parentPath}
                    activeClassName="active"
                    partiallyActive={true}
                  >
                    {parent.label}
                  </Link>
                )}
              </div>
              <div className={`dropdown-menu ${parent.opened ? 'open' : 'close'}`}>
                {childItems.map((child, index) => {

                  const childPath = child?.connectedNode?.node?.uri ?? child.url
                  const childItemId = "menu-item-" + child.databaseId

                  if (child.parentId === parent.id) {
                    return (
                      <div
                        id={childItemId}
                        key={index + child.url}
                        className={"menu-item " + childItemId}
                      >
                        <Link
                          to={childPath}
                          activeClassName="active"
                          partiallyActive={true}
                        >
                          {child.label}
                        </Link>
                      </div>
                    )
                  }
                })}
              </div>
            </div>
          )
        })}
      </div>
    </header>
  )
}


export default Header;
